import createReactSolidComponent from '../createReactSolidComponent';
export default createReactSolidComponent('minus', 'MinusSolid', [["path",{"d":"M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1","key":"svg-0"}]]);